import { GlobalServiceService } from 'src/app/services/global-service.service';
import { LocalstorageService } from './../services/localstorage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiBasic } from '../services/api-basic'
import { a } from '@angular/core/src/render3';
import { Subscription } from 'rxjs';


@Injectable()
export class FiltersProvider {

  private token = ""

  private httpOptions = {
    headers: new HttpHeaders(

      {
        'Content-Type': 'application/json',
      }
    )
  }
  appBase
  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private api: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService,
  ) {
    // this._global.base_url = this.api.base_url
    this.token = _global.token
    this.subscription = this._localstorage.getToken().subscribe(message => {
      this.token = _global.token
    });
  }

  public getInfoFilters(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/states/?" + queryData, httpOptions)
  }

  public getClustersAll(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/clusters/all?" + queryData, httpOptions)
  }

  public getRegionsAll(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/regions/all?" + queryData, httpOptions)
  }

  public getInfoFiltersRegion(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/regions/?" + queryData, httpOptions)
  }

  public getInfoFiltersLocacions(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/locations/?" + queryData, httpOptions)
  }

  public getLocationsAll(data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/filters/locations/all?" + queryData, httpOptions)
  }

  public getTypeMaintence() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/filters/maintenance/subtype/?maintenance_id=2", httpOptions)
  }

  public getUsers(user_id) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.get(this._global.base_url + "/users?user_id=" + user_id, httpOptions)
  }

  public getYears() {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};

    return this.http.get(this._global.base_url + "/maintenances/catanios/mantenimientos",httpOptions)
  }

  //Filtros de mantenimietos
  public getFilterMaintenances(id: any, data: any) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    return this.http.post(
      this._global.base_url + "/catalogs/filter/dashboard/maintenances?user_id="+id ,
      data,
      httpOptions
    );

    // return this.http.get(`${this._global.base_url}/catalogs/filter/dashboard/maintenances?user_id=1&filters={"type":[MANUFACTURA,DISTRIBUCION]}`, {})

  }

  public getInfodashboard(data: any, filters: any) {
    // var queryData = this.api.stringfyObject(data)
    // var queryFilter = this.api.stringfyFilter(filters)
    // // const currentMonth = this.getMonth()
    // if (filters) return this.http.get(`${this._global.base_url}/dashboard/maintenances?${queryData}&filters=${queryFilter}`, {})
    // else return this.http.get(`${this._global.base_url}/dashboard/maintenances?${queryData}&filters={"mes_ejecutado": "${currentMonth}"}`, {})
  }

  public getCatalog2(data: any, catalog: string) {
    const httpOptions = {
		  headers: new HttpHeaders({
			"Content-Type": "application/json",
			"Authorization": `Bearer ${this.token}`
		  })
		};
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/catalogs" + catalog + "?" + queryData,httpOptions)

  }
}
